import { geocoding, distanceMatrix, mapquest } from 'Service/axios';
import { IDistanceAndDuration } from 'Shared/Types/distance';
import { ICoordinate } from 'Shared/Types/coordinate';
import { kmToMiles } from 'Shared/Utils';

class Location {
  async getCoordinateByLocation(
    location: string,
    fieldName: string,
  ): Promise<ICoordinate | undefined> {
    const response = await geocoding.get('search', {
      params: {
        q: location,
      },
    });

    if (response.data && response.data.length) {
      const { lat, lon } = response.data[0];

      return {
        lat,
        lon,
        isMultipleChoice: response.data.length > 2,
        isValid: response.data.length < 3,
        fieldName,
      };
    }

    return {
      lat: '',
      lon: '',
      isMultipleChoice: false,
      isValid: false,
      fieldName,
    };
  }

  async getRouteDistanceAndDuration(
    coordinateFrom: string,
    coordinateTo: string,
  ): Promise<IDistanceAndDuration | undefined> {
    const response = await distanceMatrix.get('', {
      params: {
        origins: coordinateFrom,
        destinations: coordinateTo,
      },
    });
    const data = response.data?.resourceSets[0]?.resources[0]?.results[0];
    const { travelDistance, travelDuration } = data;
    const results = {
      distanceInMi: kmToMiles(travelDistance),
      durationInSec: Math.round(travelDuration * 60),
    };

    return results;
  }

  async getMilesOut(
    coordinateFrom: string,
    coordinateTo: string,
  ): Promise<IDistanceAndDuration | undefined> {
    const response = await mapquest.get('', {
      params: {
        from: coordinateFrom,
        to: coordinateTo,
      },
    });
    const data = response.data?.route;
    const { distance, time } = data;
    const results = {
      distanceInMi: Math.round(distance),
      durationInSec: Math.round(time),
    };

    return results;
  }
}

export default Location;
